<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.load_flow')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.mounting_flow.status')"
                  v-model="load_step.status"
                  keyBy="id"
                  textBy="name"
                  :options="statuses"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.mounting_flow.role')"
                  v-model="load_step.role"
                  keyBy="id"
                  textBy="name"
                  :options="roles"
                  searchable
                />
              </div>

               <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('tables.mounting_flow.step_sequence')"
                  v-model="load_step.step_sequence"
                  value="load_step.step_sequence"
                />
              </div>

            </div>

            <div class="row">
              <div class="flex md3 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="mr-1"
                  @click="save()"
                >
                  {{ $t('menu.update') }}
                </va-button>

                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'load-flow' }">
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>  
</template>

<script>
import RoleAPI from '@/services/RoleAPI'
import StatusAPI from '@/services/StatusAPI'
import LoadStepAPI from '@/services/LoadStepAPI'
import { showError } from '@/global'

export default {
  data () {
    return {
      load_step: {
        status: {},
        role: {},
        next_sequence: {
          step_sequence: '',
          name: '',
        }
      },
      statuses: [],
      roles: [],
      load_steps: []
    }
  },

  mounted(){
    StatusAPI.getAllStatuses().then(response => {
      this.statuses = response.data.statuses
    })

    RoleAPI.getRoles().then(response => {
      this.roles = response.data.roles
    })

    if (this.$route.params.load_step_id !== undefined) {
      LoadStepAPI.getLoadStepById(this.$route.params.load_step_id).then(response => {
        this.load_step = response.data.load_step
      })
    }
    
    // if (this.$route.params.load_step_id === undefined) {
    //   this.load_steps.pallet_type.id = this.$route.params.pallet_type_id
    // }
  },
  methods: {
    save () {
      if ( this.$route.params.load_step_id === undefined ){
        LoadStepAPI.create(this.load_step).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.goBack()
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      } else {
        LoadStepAPI.update(this.$route.params.load_step_id, this.load_step).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.goBack()
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      }      
    },

    goBack(){
      this.$router.push({ name: 'load-flow' })
    }
  }
}
</script>